
import styles from './index.module.scss'
import { IMAGE_TYPE, RESOURCE_TYPE, DISPLAY_TYPE } from '@utils/CONST'
import { useEffect, useMemo } from "react"
import API from '@api/api'
import { useNavigate } from 'react-router-dom';
import { workflowOfSendTask } from '@utils/workflowOfBuildTaskV2';
import { Popover, Divider } from 'antd';
import Iconfont from '@utils/Iconfont';

const BottomBtnGroups = (props) => {
    const { showTopBtns, imageType, item, displayType } = props
    const navigate = useNavigate()

    const popover = (
        <div className={styles.popoverContent}>
            <div className={styles.popoverContentLeft}>
                {
                    (imageType != IMAGE_TYPE.COMMODITY && imageType != IMAGE_TYPE.COMMODITYRECOLOR && item?.clothReColorIsPerson) && <>
                        {imageType != IMAGE_TYPE.CLOTHES && <p className={styles.footer_text} onClick={(e) => handleClick(e, IMAGE_TYPE.CLOTHES, RESOURCE_TYPE.TRYON_MODEL)} ><Iconfont type="icon-aiModelOutlined" className={styles.Icon} />AI试衣</p>}
                        {imageType != IMAGE_TYPE.SIM_TRYON && <p className={styles.footer_text} onClick={(e) => handleClick(e, IMAGE_TYPE.SIM_TRYON, RESOURCE_TYPE.SIM_TRYON)}><Iconfont type="icon-sametryOutlined" className={styles.Icon} />同版型试衣</p>}
                        {imageType != IMAGE_TYPE.MODEL && <p className={styles.footer_text} onClick={(e) => handleClick(e, IMAGE_TYPE.MODEL)}><Iconfont type="icon-aiModelOutlined" className={styles.Icon} />换模特/背景</p>}
                        {imageType != IMAGE_TYPE.SHOES && <p className={styles.footer_text} onClick={(e) => handleClick(e, IMAGE_TYPE.SHOES, RESOURCE_TYPE.TRYON_SHOES)}><Iconfont type="icon-shoesOutlined" className={styles.Icon} />鞋子上脚</p>}
                        {imageType != IMAGE_TYPE.GLASSES_TRYON && <p className={styles.footer_text} onClick={(e) => handleClick(e, IMAGE_TYPE.GLASSES_TRYON, RESOURCE_TYPE.GLASSES_TRYON)}><Iconfont type="icon-glassesOutlined" className={styles.Icon} />眼镜试戴</p>}
                        {imageType != IMAGE_TYPE.POSE_TRYON && <p className={styles.footer_text} onClick={(e) => handleClick(e, IMAGE_TYPE.POSE_TRYON)}><Iconfont type="icon-poseFantasyOutlined" className={styles.Icon} />姿势裂变</p>}
                        {imageType != IMAGE_TYPE.CLOTH_RECOLOR && <p className={styles.footer_text} onClick={(e) => handleClick(e, IMAGE_TYPE.CLOTH_RECOLOR)}><Iconfont type="icon-recolorOutlined" className={styles.Icon} />服饰换色</p>}
                        {imageType != IMAGE_TYPE.MODEL_VIDEO && <p className={styles.footer_text} onClick={(e) => handleClick(e, IMAGE_TYPE.MODEL_VIDEO)}><Iconfont type="icon-tryonVideoOutlined" className={styles.Icon} />生成视频</p>}
                    </>
                }
                {
                    imageType != IMAGE_TYPE.COMMODITYRECOLOR && <p className={styles.footer_text} onClick={(e) => handleClick(e, IMAGE_TYPE.COMMODITYRECOLOR)} ><Iconfont type="icon-recolorOutlined" className={styles.Icon} />商品换色</p>
                }
                {
                    (imageType == IMAGE_TYPE.COMMODITYRECOLOR) &&
                    <p className={styles.footer_text} onClick={(e) => handleClick(e, IMAGE_TYPE.COMMODITY)} ><Iconfont type="icon-commidityOutlined" className={styles.Icon} />AI商品</p>
                }
            </div>
            <Divider type="vertical" style={{ height: '150px', marginRight: '20px' }} />
            <div className={styles.popoverContentRight}>
                {
                    (imageType != IMAGE_TYPE.COMMODITY && imageType != IMAGE_TYPE.COMMODITYRECOLOR) &&
                    <p
                        className={styles.footer_text}
                        onClick={(e) => handleClick(e, IMAGE_TYPE.AIEDIT, 'handRepair')}>
                        <Iconfont type="icon-handRepairOutlined" className={styles.Icon} />手部修复</p>
                }

                <p
                    className={styles.footer_text}
                    onClick={(e) => handleClick(e, IMAGE_TYPE.AIEDIT, 'magicErase')}>
                    <Iconfont type="icon-magicRemoveOutlined" className={styles.Icon} />魔法擦除</p>
                <p className={styles.footer_text} onClick={(e) => handleClick(e, IMAGE_TYPE.AIEDIT, 'image_extraction')}><Iconfont type="icon-mattingOutlined" className={styles.Icon} />智能抠图</p>
                <p className={styles.footer_text} onClick={(e) => handleClick(e, IMAGE_TYPE.AIEDIT, 'imageResize')}><Iconfont type="icon-picResizeOutlined" className={styles.Icon} />高清改尺寸</p>
            </div>
        </div>
    )

    const MoreOutMenuContent = (
        <div className={styles.MoreOutMenuContent}>
            <Popover placement="top" content={popover}>
                <span className={`${styles.spanItem} ${styles.spanItem2}`}><Iconfont type="icon-menuOutlined" /></span>
            </Popover>
        </div>
    )

    const handleClick = async (e, jumpTotype, targetType = "inputImage") => {
        e.stopPropagation()
        let noWaterRes = await API.commonDownload({ taskId: item?.taskId })
        if (noWaterRes?.code != 0) throw new Error(noWaterRes?.message)
        const image = noWaterRes.data

        // 跳转AI编辑
        if (targetType == 'handRepair') {
            navigate("/home/aiEdit", { state: { menuKey: 'handRepair', picUrl: image } })
            return
        } else if (targetType == 'magicErase') {
            navigate("/home/aiEdit", { state: { menuKey: 'magicErase', picUrl: image } })
            return
        } else if (targetType == 'image_extraction') {
            window.open(image ? `/home/image_extraction?url=${encodeURIComponent(image)}` : `/home/image_extraction`, '_blank')
            return
        } else if (targetType == 'imageResize') {
            window.open(image ? `/home/imageResize?url=${encodeURIComponent(image)}` : `/home/imageResize`, '_blank')
            return
        }

        const res = await workflowOfSendTask(jumpTotype, image, targetType)
        if (!res) return
        const { pathname, options } = res
        navigate(pathname, options)
    }

    const goEdit = async (e) => {
        e.stopPropagation()
        let res = await API.commonDownload({ taskId: item.taskId })
        if (res?.code != 0) throw new Error(res?.message)
        const image = res.data
        navigate("/home/aiEdit", { state: { menuKey: 'magicErase', picUrl: image } })
    }

    const isShowGenerate = useMemo(() => {
        return displayType == DISPLAY_TYPE.GENERATE
    }, [displayType])

    return (
        (showTopBtns && imageType != IMAGE_TYPE.MODEL_VIDEO) &&
        (<div className={styles.BottomBtnGroups}>
            {MoreOutMenuContent}
            {/* {
                isShowGenerate ? MoreOutMenuContent : <Popover
                    placement="left"
                    content={MoreOutMenuContent}
                    arrow={false}
                    styles={{ body: { borderRadius: '12px', padding: 0, background: 'transparent', boxShadow: 'none' } }}
                >
                    <span onClick={(e) => e.stopPropagation()}>
                        <MoreOutlined className={styles.Icon} />
                    </span>
                </Popover>
            } */}

        </div>)
    )
}

export default BottomBtnGroups